import React from 'react';
import { Clock, Utensils, Heart } from 'lucide-react';
interface RecipeCardProps {
  day: string;
  title: string;
  ingredients: string;
  steps: string;
  benefit: string;
}
export function RecipeCard({
  day,
  title,
  ingredients,
  steps,
  benefit
}: RecipeCardProps) {
  return <div className="my-8 overflow-hidden rounded-2xl border border-sage/20 bg-white shadow-sm transition-all hover:shadow-md" data-id="element-140">
      <div className="bg-sage/10 px-6 py-4 border-b border-sage/20" data-id="element-141">
        <div className="flex items-center justify-between mb-1" data-id="element-142">
          <span className="font-sans text-sm font-bold uppercase tracking-wider text-forest/70" data-id="element-143">
            {day}
          </span>
          <div className="flex items-center gap-1 text-forest/60 text-sm font-sans font-medium" data-id="element-144">
            <Clock className="h-4 w-4" data-id="element-145" />
            <span data-id="element-146">15 min</span>
          </div>
        </div>
        <h4 className="font-sans text-xl md:text-2xl font-semibold text-forest m-0" data-id="element-147">
          {title}
        </h4>
      </div>

      <div className="p-6 md:p-8 space-y-6" data-id="element-148">
        <div data-id="element-149">
          <h5 className="font-sans text-sm font-bold uppercase tracking-wider text-charcoal/60 mb-3 flex items-center gap-2" data-id="element-150">
            <Utensils className="h-4 w-4" data-id="element-151" />
            Ingredientes
          </h5>
          <p className="font-serif text-charcoal/90 m-0" data-id="element-152">{ingredients}</p>
        </div>

        <div className="h-px w-full bg-sage/20" data-id="element-153" />

        <div data-id="element-154">
          <h5 className="font-sans text-sm font-bold uppercase tracking-wider text-charcoal/60 mb-3" data-id="element-155">
            Paso a paso
          </h5>
          <p className="font-serif text-charcoal/90 m-0" data-id="element-156">{steps}</p>
        </div>

        <div className="rounded-xl bg-cream p-4 border border-gold/20" data-id="element-157">
          <div className="flex items-start gap-3" data-id="element-158">
            <Heart className="h-5 w-5 text-gold flex-shrink-0 mt-0.5" data-id="element-159" />
            <div data-id="element-160">
              <span className="font-sans text-sm font-bold text-gold block mb-1" data-id="element-161">
                Beneficio
              </span>
              <span className="font-serif text-charcoal/80 text-base" data-id="element-162">
                {benefit}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}